import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const dlItemsSlice = createSlice({
	name: 'dlItems',
	initialState,
	reducers: {
		setDlItems: (state, action) => {
			return action.payload;
		}
	}
});

export const { setDlItems } = dlItemsSlice.actions;
export default dlItemsSlice.reducer;
